import { baseAPI } from "../../services/api";
import { transactionID } from "../../services/helpers";

export function sendSmsCodeRequest({ msisdn, authToken }) {
  return baseAPI.post("/v2/sendSMS", {
    transactionID: transactionID("SSC"),
    MSISDN: msisdn,
    text: "Seu Token de Acesso ao site é:",
    tokenValidate: true,
  }, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}
